import { DEFAULT_PAGE_SIZE } from '../constants';

export interface PaginationDataSet {
  page: number;
  pageSize: number;
}

export const paginationDefaults: PaginationDataSet = {
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
};
